export default __webpack_public_path__ + "static/media/musicwhite.4bfea431.svg";